import ar from './ar'
import en from './en'

export default {'ar':ar,'en':en}